import { Link } from "react-router-dom";
import { Instagram, MapPin, Clock, Phone } from "lucide-react";
import { site } from "@/config/site";

export const Footer = () => (
  <footer className="bg-night text-white" data-testid="site-footer">
    <div className="container-wide py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <Link to="/" className="inline-block">
          <img src="/images/lavenza-spa-logo.png" alt="Lavenza Spa Bursa logo" width="840" height="689" loading="lazy" className="logo-glow w-[220px] h-auto" />
        </Link>
        <p className="mt-3 text-xs font-light tracking-[0.18em] text-gold/90" data-testid="footer-slogan">Kendine İyi Bak · Yenilen · Dengeyi Keşfet</p>
        <p className="mt-5 text-sm text-white/70 leading-relaxed">
          Bursa Nilüfer Konak Mahallesi'nde klasik, medikal ve soft masaj ile kese & köpük hizmeti. Hijyenik, sakin ve konforlu ortam.
        </p>
        <a href={site.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="mt-5 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 hover:bg-gold hover:text-night transition-colors" data-testid="footer-instagram">
          <Instagram size={18} aria-hidden="true" />
        </a>
      </div>

      <div>
        <h2 className="text-base font-bold text-gold">Hizmetler</h2>
        <ul className="mt-4 space-y-2.5">
          {site.services.map((s) => <li key={s.slug}><Link to={s.path} className="footer-link">{s.name}</Link></li>)}
          <li><Link to="/masaj-hizmetleri" className="footer-link font-semibold text-gold">Tüm Hizmetler</Link></li>
        </ul>
      </div>

      <div>
        <h2 className="text-base font-bold text-gold">Bölgeler</h2>
        <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 lg:grid-cols-1" data-testid="footer-landing-links">
          {site.landingLinks.map((l) => <li key={l.path}><Link to={l.path} className="footer-link">{l.label}</Link></li>)}
        </ul>
      </div>

      <div>
        <h2 className="text-base font-bold text-gold">İletişim</h2>
        <address className="not-italic mt-4 space-y-3 text-sm text-white/70">
          <p className="flex gap-2"><MapPin size={16} className="text-gold shrink-0 mt-0.5" aria-hidden="true" /><span data-testid="footer-address">{site.address.full}</span></p>
          <p className="flex gap-2"><Phone size={16} className="text-gold shrink-0 mt-0.5" aria-hidden="true" /><a href={site.phoneTel} className="hover:text-gold" data-testid="footer-phone">{site.phoneDisplay}</a></p>
          <p className="flex gap-2"><Clock size={16} className="text-gold shrink-0 mt-0.5" aria-hidden="true" /><span data-testid="footer-hours">{site.openingHours.text}</span></p>
        </address>
        <a href={site.whatsappUrl} target="_blank" rel="noopener noreferrer" className="mt-4 inline-block footer-link" data-testid="footer-whatsapp">WhatsApp'tan Randevu</a>
        <p className="mt-4 text-xs text-white/50">{site.priceNote}</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-wide py-5 text-xs text-white/50 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
        <div className="flex flex-col gap-1">
          <span>© {new Date().getFullYear()} {site.name}. Tüm hakları saklıdır.</span>
          <span data-testid="footer-credit">
            Web Sitesi ve Dijital Çözümler:{" "}
            <a href="https://wa.me/905324751871" target="_blank" rel="noopener nofollow" className="hover:text-gold underline-offset-2 hover:underline">Bana Bi Media</a>
          </span>
        </div>
        <nav aria-label="Alt menü" className="flex gap-5">
          <Link to="/hakkimizda" className="hover:text-gold">Hakkımızda</Link>
          <Link to="/masaj-hizmetleri" className="hover:text-gold">Hizmetler</Link>
          <Link to="/iletisim" className="hover:text-gold">İletişim</Link>
        </nav>
      </div>
    </div>
  </footer>
);
